/*
 * R5 modifier-key keycap glyphs (the ⌘ cloverleaf, CTL, SHFT, OPT, ALT) that
 * BMenuItem::DrawShortcutSymbol blits next to a menu accelerator.
 *
 * The PNGs are compiled from the libbe.so _menudata_* CMAP8 bitmaps by
 * scripts/gen-bitmaps.ts (content-aware crop to a single keycap). Widths vary
 * per glyph/state; menu-glyphs.test.ts asserts these constants match the
 * committed PNGs.
 */

import alt from "../assets/menu/keycap-alt.png";
import altDisabled from "../assets/menu/keycap-alt-disabled.png";
import command from "../assets/menu/keycap-command.png";
import commandDisabled from "../assets/menu/keycap-command-disabled.png";
import control from "../assets/menu/keycap-control.png";
import controlDisabled from "../assets/menu/keycap-control-disabled.png";
import option from "../assets/menu/keycap-option.png";
import optionDisabled from "../assets/menu/keycap-option-disabled.png";
import shift from "../assets/menu/keycap-shift.png";
import shiftDisabled from "../assets/menu/keycap-shift-disabled.png";
import win from "../assets/menu/keycap-win.png";
import winDisabled from "../assets/menu/keycap-win-disabled.png";

export type BeModifierGlyph = { url: string; width: number; height: number };

export type BeMenuModifier = "command" | "control" | "shift" | "option" | "alt" | "win";

export const MENU_MODIFIER_GLYPHS: Record<BeMenuModifier, { normal: BeModifierGlyph; disabled: BeModifierGlyph }> = {
	command: {
		normal: { url: command, width: 17, height: 11 },
		disabled: { url: commandDisabled, width: 17, height: 11 },
	},
	control: {
		normal: { url: control, width: 17, height: 11 },
		disabled: { url: controlDisabled, width: 17, height: 11 },
	},
	shift: {
		normal: { url: shift, width: 22, height: 11 },
		disabled: { url: shiftDisabled, width: 22, height: 11 },
	},
	option: {
		normal: { url: option, width: 17, height: 11 },
		disabled: { url: optionDisabled, width: 17, height: 11 },
	},
	alt: {
		normal: { url: alt, width: 17, height: 11 },
		disabled: { url: altDisabled, width: 17, height: 11 },
	},
	win: {
		normal: { url: win, width: 16, height: 11 },
		disabled: { url: winDisabled, width: 16, height: 11 },
	},
};

/**
 * DrawShortcutSymbol's blit order, which a caller cannot vary: fModifiers is a
 * bitmask. `alt` and `command` share the last slot, being one bit apiece of
 * B_COMMAND_KEY -- `BMenu::sSwapped` picks the cap. `win` ships in libbe's
 * menu data but no draw path we have blits it, so it is placed last by choice.
 */
export const MENU_MODIFIER_ORDER: readonly BeMenuModifier[] = ["shift", "control", "option", "alt", "command", "win"];
